import type { MapControl } from "./types";

/**
 * Default controls configuration for InteractiveMap
 *
 * Provides a sensible default set of controls:
 * - Navigation (compass + geolocate + reset zoom) in bottom-right
 *
 * These controls cover the most common use case while keeping
 * the map interface clean and uncluttered.
 */
export const DEFAULT_CONTROLS: MapControl[] = [
  {
    type: "navigation",
    position: "bottom-right",
    showCompass: true,
    showGeolocate: true,
    showResetZoom: true,
  },
];
